import React from 'react';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';

// GLOBAL FUNCTIONS
import { doCallback } from 'functions.js';

// HOOKS
import { useRecordContext } from 'helpers/getRecordData';

// GLOBAL PARTS
import Logs from 'parts/logs/Logs';

// VARIABLES
const COMMENTS_FETCH_ARGS = {
  endpoints: ENDPOINTS.sales.comments
}
const ACTIVITY_FETCH_ARGS = {
  endpoint: ENDPOINTS.sales.activityLog,
  onSuccess: data => data
}

// COMPONENTS
const SalesCommentsLog = props => {

  // CONTEXT
  const { refetchRecord } = useRecordContext() || {};

  // RENDER
  return (
    <Logs.Comments
      fetchArgs={COMMENTS_FETCH_ARGS}
      controlNames={{
        body: 'comment'
      }}
      formArgs={{
        endpoint: ENDPOINTS.sales.comments.add,
        params: {
          activity_type_id: 7
        },
        addAsTask: true,
        onSuccess: () => doCallback(refetchRecord)
      }}
      dataProcessor={({
        comments,
        posted_by,
        date_created
      }) => ({
        body: comments,
        createdBy: posted_by,
        createdDate: date_created
      })}
      {...props}
    />
  );
};
const SalesActivityLog = props => {
  return (
    <Logs.Activity
      fetchArgs={ACTIVITY_FETCH_ARGS}
      {...props}
    />
  );
  
}
SalesActivityLog.Tab = Logs.Activity.Tab;

// MAIN COMPONENT
const SalesLogs = () => (
  <Logs
    logs={{
      dealTasks: Logs.DealTasks,
      comments: SalesCommentsLog,
      activity: SalesActivityLog
    }}
  />
);  

// EXPORT
export default SalesLogs;